import React from 'react';
import PropTypes from 'prop-types';

import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import './style.scss';

//main component
const PdButton = ({
  type,
  outline,
  children,
  onClick,
  htmlType = 'button',
  full = false,
  noPadding = false,
  style = {},
  className = '',
  loading = false,
  disabled = false,
}) => {
  let addOnClass = `pd-button--${type}`;
  if (outline) addOnClass = `pd-button--ghost-${type}`;
  const isLoading = loading ? `${addOnClass}-loading` : '';
  if (full) full = `pd-button--full`;
  if (noPadding) noPadding = `pd-button--padding-0`;

  const loadingIcon = (
    <LoadingOutlined
      style={{
        color: '#fff',
        fontSize: 24,
        marginRight: 10,
        display: 'inline-block',
      }}
      spin
    />
  );

  return (
    <button
      className={`pd-button ${addOnClass} ${full} ${noPadding} ${isLoading} ${className}`}
      type={htmlType}
      style={{...style, whiteSpace: 'nowrap'}}
      disabled={disabled || isLoading}
      onClick={onClick}>
      {isLoading  ? <Spin indicator={loadingIcon} /> : children}
    </button>
  );
};

export default PdButton;

PdButton.propTypes = {
  children: PropTypes.any,
  className: PropTypes.any,
  disabled: PropTypes.bool,
  full: PropTypes.bool,
  htmlType: PropTypes.string,
  noPadding: PropTypes.bool,
  onClick: PropTypes.any,
  outline: PropTypes.any,
  style: PropTypes.object,
  type: PropTypes.any,
  loading: PropTypes.bool,
};
